import { Row, Col, Card, Container } from "react-bootstrap";
import { JitsiMeeting } from '@jitsi/react-sdk';
import { BASE_URL_WS } from "../../api/Routes";
import { useEffect, useState } from "react";
import moment from "moment";
import SockJsClient from 'react-stomp';
import CountdownComponent from "../CountdownComponent";
import { useTranslation } from "react-i18next";
import Archivos from "../Archivos";

export default function OnCitaV2({cita, onApiReady=()=>{}, onComplete}){
    const [startMeeting, setStartMeeting] = useState(null)
    const [serverTime, setServerTime] = useState(null)
    const [clientTime, setClientTime] = useState(null)
    const [almostDown, setIsAlmostDown] = useState(false)
    const { t } = useTranslation();

    useEffect(()=>{
        let minToPlus = 0
        let serverTime = moment(cita.currentTime, "DD/MM/YYYY HH:mm:ss")
        let startAppointment = moment(cita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss")

        if(serverTime.isBefore(startAppointment)){
            let diff = startAppointment.diff(serverTime, "seconds")
            minToPlus = diff
        }
        minToPlus *= 1000

        setClientTime(Date.now())
        setServerTime(moment(cita.currentTime, "DD/MM/YYYY HH:mm:ss").valueOf()+minToPlus)      
        setStartMeeting(moment(cita.scheduleDTO.dateTimeEnd, "YYYY-MM-DDTHH:mm:ss").valueOf())
    }, [])

    const handleMessageSocket = (message) =>{
        if(message.message){
            setStartMeeting(moment(message.message, "YYYY-MM-DDTHH:mm:ss").valueOf())
            setIsAlmostDown(false)
        }
    }
    return (
        <>
            <div className="bg-footer-1 mb-5 p-5">
                <Container>
                    <Row>
                        <Col xs="12" md={{span: 10, offset: 1}}>
                            <Card className={`mb-1 shadow-sm`}>
                                <Card.Body>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div>
                                            <span className="colorLabel">{t('cita_comenzado')}</span>
                                        </div>
                                        <div className="colorLabel">                                    
                                            {startMeeting &&
                                            <CountdownComponent 
                                                date={startMeeting} 
                                                serverTime={serverTime}
                                                setServerTime={setServerTime}
                                                clientTime={clientTime}
                                                setClientTime={setClientTime}
                                                onComplete={onComplete}
                                                setIsTime={() => {}}
                                                setIsAlmostDown={setIsAlmostDown}
                                                setShowExtraTime={() => {}}
                                            />}
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                            <div className="py-3">
                                <JitsiMeeting
                                    roomName = {cita.token_conference}
                                    domain={cita.url_conference}
                                    getIFrameRef = { node => node.style.height = '400px' }
                                    configOverwrite = {{
                                        startWithAudioMuted: false,
                                        disableModeratorIndicator: true,
                                        startScreenSharing: false,
                                        enableEmailInStats: false,
                                        toolbarButtons: [
                                            "microphone",
                                            "camera",
                                            "fullscreen",
                                            "chat",
                                            "recording",
                                            "select-background",
                                        ],
                                    }}
                                    userInfo = {{
                                        displayName: `${cita.patientDTO.name} ${cita.patientDTO.lastName}`
                                    }}
                                    onApiReady = {onApiReady}
                                    jwt={cita?.scheduleDTO?.jwtPatient}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="my-3" style={{marginTop: '-5%'}}>
                <Container>
                    <Row>
                        <Col xs="12" md={{span: 10, offset: 1}}>
                            <Archivos appointmentId={cita.id} noToken={true} paciente={cita.patientDTO}/>
                        </Col>
                    </Row>
                </Container>
            </div>
            {
                cita && <SockJsClient 
                    url={`${BASE_URL_WS}/ws`} 
                    topics={[`/user/${cita.id}/queue/notify`]}
                    onMessage={(message) => handleMessageSocket(message)} 
                />
            }
        </>
        
        
    )

}